/*!
=========================================================
* その他依頼一覧
=========================================================
*/
import React from "react";

import {
  Button,
  Table, Col, CardHeader, CardTitle, Row, Card
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import Format from '../../common/Format';
import DialogBase from '../Base/DialogBase';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import InputDatetime from '../FormParts/InputDatetime';
import InputCheckBox from "../FormParts/InputCheckBox";
import Definition from '../../common/Definition';
import {
  cst_request_other_status,
  cst_tax_in_flag,
  cst_payment_request_status
} from '../../variables/codes_map'
import CustomTd from '../ViewParts/CustomTd';
import InputNumber from '../FormParts/InputNumber';
import InputRadio from '../FormParts/InputRadio';
import OptionConvert from '../../common/OptionConvert';
import WithRole from '../FormParts/ButtonWithRole';
import Common from '../../common/Common';
import { GetMessage, getErrorCodes } from "../../variables/message";
import InputInvoice from "../ViewParts/InputInvoice";
class List extends ListBase {
  default_column = [
    { Header: '案件ID',accessor: 'REQUEST__request_natural_id',headerClassName:'text-center',className:'text-left text-top',width:130,minWidth:50},
    { Header: '依頼内容',accessor: '___JOIN_request_other_qty',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: 'ステータス',accessor: 'REQUEST__request_other_status',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '着手期限日',accessor: 'REQUEST__request_other_deadline',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '顧客情報（下請）',accessor: '___JOIN_subcontract_customer_information',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '現場名/工事番号',accessor: '___JOIN_project_information_estimate',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '現場住所',accessor: '___JOIN_project_addr',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '契約期間',accessor: '___JOIN_want_other_date',headerClassName:'text-center',className:'text-left text-top',width:185,minWidth:50},
    { Header: 'その他依頼資料',accessor: '___JOIN_request_other_documents',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50, sortable : false},
    { Header: '見積',accessor: 'actions_3',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50, sortable : false},
    { Header: '仕入依頼',accessor: 'actions_1',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50, sortable : false},
    { Header: '支払期日',accessor: 'PAYMENT__payment_limit_date',headerClassName:'text-center',className:'text-left text-top',width:130,minWidth:50,defaultView:true},
    { Header: '案件状況更新',accessor: 'actions_2',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50, sortable : false},
    { Header: 'Close',accessor: 'close',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50, sortable : false},
    { Header: '担当者',accessor: 'REQUEST__other_survey_account',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50, sortable : false},
    { Header: '案件状況メモ',accessor: 'ESTIMATE__order_memo',headerClassName:'text-center',className:'text-left text-top',width:500,minWidth:50,defaultView:true},
    { Header: '差戻メモ',accessor: 'ESTIMATE__payment_return_memo',headerClassName:'text-center',className:'text-left text-top',width:500,minWidth:50,defaultView:true},
    { Header: '最終更新情報',accessor: '___JOIN_request_update',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: 'その他依頼一覧',
      add_url: '',
      base_search_url: '/api/requestpayment/other',
      search_url: '/api/requestpayment/other/unlimit',

      REQUEST__request_natural_id: "",
      CUSTOMER_USER__customer_user_tel: "",

      userData:[],
      searchData:{
        values:{
          // payment_request_status: ["0","2"],
        },
        errors:{},
        requiredData:{}
      },
      column: this.default_column,
      detail_search:false,
      valid: true,
      error_modal: false,
      message:"",
      dialogData:{},
      landmark_user:[],
      auto_scroll:true,
    });
    this.DialogChangeStatus = React.createRef()
    this.DialogCloseProject = React.createRef()
    this.DialogConfirmEstimate = React.createRef()
    this.validateCallback = this.validateCallback.bind(this)
    this.getLastUpdaedUser = this.getLastUpdaedUser.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
    this.openDialogCofirmEstimate = this.openDialogCofirmEstimate.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.options(res.Data)
      const userData = res.Data.map((user)=>{
        return {
          label:user.name,
          value:user.id
        }
      })
      this.setState({
        landmark_user:user_list,
        userData
      }, () => {
        this.search(false);
      });
    })
    
  }
  componentDidUpdate(){
    console.log(this.state);
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.landmark_user;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  dataMap(data) {
    console.log(data)
    return data.map((prop, key) => {
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const isCloseProjDisabled = prop.survey_status === 9 || prop.payment_request_status === 1 || prop.request_other_status === 6
      const request_other_status = prop.survey_status === 9 ? `Closed (${Common.getValueFormDictArray(cst_request_other_status,prop.request_other_status)})`:Common.getValueFormDictArray(cst_request_other_status,prop.request_other_status)
      const otherSurveyAccountName = this.state.userData.find(user => user.value == prop.other_survey_account)
      return {
        id: key,
        prop,
        REQUEST__request_natural_id: (<Link target="_blank" to={"/construction/other/detail/" + prop.request_ulid} color="facebook">{prop.request_natural_id}</Link>),
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
        REQUEST__request_other_status: request_other_status,
        REQUEST__request_other_deadline: Format.format_date(prop.request_other_deadline),
        ___JOIN_project_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_project_information_estimate: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_estimate', prop)}} />,
        ___JOIN_request_other_qty: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_other_qty', prop)}} />,
        ___JOIN_request_update: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_update', prop_tmp)}} />,
        ___JOIN_want_other_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_want_other_date', prop)}} />,
        PAYMENT__payment_limit_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_limit_date', prop)}} />,
        actions_1: (prop.request_type>4?"":<ButtonWithRole button_id="BTN_FX_01_02880" size="sm" onClick={() => { this.props.history.push("other/add/"+prop.request_natural_id) }} className="text-center" disabled={prop.payment_request_status == 1 || prop.payment_request_status == 5 || prop.survey_status === 9}>仕入<br/>依頼</ButtonWithRole>),
        actions_2: (<ButtonWithRole button_id="BTN_FX_01_02890" size="sm" onClick={() => { this.DialogChangeStatus.current.show(); this.setState({dialogData: prop}) }} className="text-center" disabled={prop.request_other_status == 6 || prop.survey_status === 9}>案件状況<br/>更新</ButtonWithRole>),
        close: (<ButtonWithRole size="sm" button_id="BTN_FX_01_02911" onClick={() => { this.DialogCloseProject.current.show(); this.setState({dialogData: prop}) }} className="text-center" disabled={isCloseProjDisabled}>案件<br/>Close</ButtonWithRole>),
        actions_3: (<ButtonWithRole button_id="BTN_FX_01_03320" size="sm" onClick={()=>this.openDialogCofirmEstimate(prop)} className="text-center" disabled={false}>見積確認</ButtonWithRole>),
        REQUEST__other_survey_account: otherSurveyAccountName ? otherSurveyAccountName["label"]: "",
        ESTIMATE__order_memo: prop.order_memo,
        ESTIMATE__payment_return_memo: prop.payment_return_memo,
        ___JOIN_request_other_documents: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_other_documents', prop)}} />
      }
    });
  }

  openDialogCofirmEstimate (prop) {

    let {
      survey_cost_commission_invoice_business_type,
      survey_cost_commission_invoice_registration_number,
    } = prop
    console.log(prop)
    switch (survey_cost_commission_invoice_business_type) {
      case 1:{
        if ( survey_cost_commission_invoice_registration_number == null || survey_cost_commission_invoice_registration_number == "" ) {
          survey_cost_commission_invoice_business_type = 2
        }
      }break;
      default:{
        survey_cost_commission_invoice_business_type = 2
      }break;
    }
    prop["survey_cost_commission_invoice_business_type"] = survey_cost_commission_invoice_business_type
    
    this.setState({
      dialogData: prop,
    }, ()=> this.DialogConfirmEstimate.current.show())
  }  

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
      Request.get("/api/setting/datetime",{}, response => {
        const settingDatetime = new Date(response.Data.setting_datetime.value);
        const now = new Date();
        const isFuture = now < settingDatetime

        this.setState({
          paging: {
            "index": parseInt(searchParmas["pager_index"]),
            "limit": parseInt(searchParmas["pager_limit"])
          },  
          data: this.dataMap(res.Data),
          setting_datetime:res.Data.setting_datetime,
          isFuture: isFuture,
        });
      });
    })
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <InputText
            label='案件ID'
            name='REQUEST__request_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
          />
        </Col>
        <Col md="3">
          <InputText
            label='市区町村'
            name='PROJECT__site_city'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
          />
        </Col>
        <Col md="3">
          <InputText
            label='番地（町名以降）'
            name='PROJECT__site_address'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
          />
        </Col>
        <Col md="3" className="mt-3">
        <InputCheckBox
          label='Closeした案件も表示する'
          name='REQUEST__survey_status'
          labelOn={false}
          checkedValue={9}
          uncheckedValue={0}
          validateCallback={this.validateCallback}
          rootData={this.state.searchData}
          />
        </Col>
        <Col md="3">
          <InputCheckBox
            label='仕入依頼ステータス'
            name='ESTIMATE__payment_request_status'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_payment_request_status}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>        
      </>
    );
  }
  add_field_cols() {
    return (
	<>
        
	</>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<>
      <Col md="4">
        <InputSelect
          label='最終更新者'
          name='REQUEST__lastupdate_user_id'
          options={this.state.userData}
          isSearchable={true}
          labelOn={true}
          validateCallback={this.validateCallback}
          rootData={this.state.searchData}
          validateType={'search'}
        />
      </Col>
      <Col md="4">
        <InputDatetime
          label='着手期限日（FROM）'
          name='REQUEST__request_other_deadline_from'
          labelOn={true}
          validateCallback={this.validateCallback}
          rootData={this.state.searchData}
          validateType={'search'}
        />
      </Col>
      <Col md="4">
        <InputDatetime
          label='着手期限日（TO）'
          name='REQUEST__request_other_deadline_to'
          labelOn={true}
          validateCallback={this.validateCallback}
          rootData={this.state.searchData}
          validateType={'search'}
        />
      </Col>
      </>);
  }
  
  checkbox_field_cols(){
    return (
      <></>
    );
  }

  dialog_defines() {
    return (
      <>
        <DialogChangeStatus
          ref={this.DialogChangeStatus}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          isFuture={this.state.isFuture}
          toggleErrorModalCallback={()=>this.props.alertModal.current.showErrorModal({messageNo:2401})}
          refreshCallback={() => this.search(true)}
        />
        <DialogCloseProject
          ref={this.DialogCloseProject}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          toggleErrorModalCallback={()=>this.props.alertModal.current.showErrorModal({messageNo:2401})}
          refreshCallback={() => this.search(true)}
        />
        <DialogConfirmEstimate
          ref={this.DialogConfirmEstimate}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          toggleErrorModalCallback={()=>this.props.alertModal.current.showErrorModal({messageNo:2401})}
          refreshCallback={() => this.search(true)}
        />
      </>
    );
  }
}

export class DialogChangeStatus extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '案件状況更新',
      estimate: {
        values:{...this.props.data,
          request_other_deadline: this.props.data.request_other_deadline && this.props.data.request_other_deadline != null? this.props.data.request_other_deadline: new Date()
        },
        errors:{},
        requiredData:{
          request_other_deadline:[GetMessage(2024)], 
        }
      }
    });
    this.validate = this.validate.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.data !== this.props.data || prevState.modal !== this.state.modal){
      let request_other_deadline = this.props.data.request_other_deadline && this.props.data.request_other_deadline != null ? this.props.data.request_other_deadline: this.state.estimate.values.request_other_deadline

      this.setState((prevState) => {
        const updatedValues = {
          ...this.props.data,
          invoice_amt: this.props.data.quote_subtotal_amt - (this.props.data.estimate_detail_amt_ex ?this.props.data.estimate_detail_amt_ex :0),
          estimate_detail_amt: this.props.data.quote_subtotal_amt - (this.props.data.estimate_detail_amt_ex ?this.props.data.estimate_detail_amt_ex :0),
          quote_subtotal_amt: this.props.data.quote_subtotal_amt ,
          invoice_user_memo : this.props.data.order_memo,
          request_other_deadline : request_other_deadline
        }
        const paymentDone = this.props.data.payment_data.some((payment)=>payment.payment_status == 6);
        const paymentRequestStatus = this.props.data.payment_request_status;
        this.setState({
          disablePositive: paymentDone || paymentRequestStatus == 6 ? true : false
        })

        return {
          estimate: {
            ...this.state.estimate,
            values: updatedValues,
            errors: {
              request_other_deadline : request_other_deadline ? undefined : [GetMessage(2024)]
            },
            requiredData:{
              request_other_deadline:[GetMessage(2024)], 
            },
            invoiceInfoIsSet: this.invoiceInfoIsSet()
          },
          disablePositive: paymentDone || paymentRequestStatus === 6,
        }
      },()=>{
        console.log(this.state.estimate.values)
      });
    }
  }

  invoiceInfoIsSet() {
    const request_type = this.props.data.request_type
    const survey_cost_commission_invoice_business_type = this.props.data.survey_cost_commission_invoice_business_type
    const survey_cost_commission_invoice_registration_number = this.props.data.survey_cost_commission_invoice_registration_number

    if((request_type == 4 || request_type == 5 || request_type == 6) && ( // 道路使用許可であり
        (survey_cost_commission_invoice_business_type != 1 && survey_cost_commission_invoice_business_type != 2) || // 支払先が登録されていない（適格事業者でも免税でもない）
        (survey_cost_commission_invoice_business_type == 1 && this.isNull(survey_cost_commission_invoice_registration_number)) // もしくは支払先が適格事業者なのに事業者番号が空
    )) {
      return false
    }

    return true
  }

  validate() {
    let message = getErrorCodes(this.state.estimate.errors)

    console.log(message,this.state.estimate);

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    if(!this.state.estimate.invoiceInfoIsSet && this.state.estimate.values.request_other_status == 6) {
      this.props.alertModal.current.showErrorModal({messageNo:["適格事業者番号が登録されていません。"]});
      return false;
    }

    return true;
  }

  handleClickPositive() {
    this.props.handleClickPositive && this.props.handleClickPositive();
    if(this.validate()) {
      // 調整額 更新API呼び出し
      // url put estimate??? need to check after testable data created
      
      const params = {
        ...this.state.estimate.values,
        ...(this.state.estimate.values.request_other_status<6
          ? {
            order_memo:this.state.estimate.values.invoice_user_memo,
            invoice_user_memo:undefined
          } : {
            invoice_user_memo:this.state.estimate.values.invoice_user_memo
          })
      }
      const url = '/api/request/other/status/' + this.state.estimate.values.ulid;
      // return
      // Request.put(url, params, res => {
      //   this.toggleModal();
      //   this.props.refreshCallback();
      // });
      Request.put(url, params, res => {
        if (res.Code == 816){
          this.props.alertModal.current.confirmCheck({
            title: res.data.message,
            messageNo: 2616,
            closeBtn: false
          }, ()=>{
            this.props.refreshCallback()　//コレは元々の処理
          }, false)
        }else{
          this.toggleModal();
          this.props.refreshCallback();
        }
      });
    }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.toggleModal();
  }

  isNull(value){
    if(value === undefined || value === null || value === ""){
      return true
    }
    return false;
  }
  validateEstimateDetailEx (estimate) {
    const estimate_detail_name_ex = this.isNull(estimate.values.estimate_detail_name_ex) ? null: estimate.values.estimate_detail_name_ex
    const estimate_detail_amt_ex = this.isNull(estimate.values.estimate_detail_amt_ex) ? null: estimate.values.estimate_detail_amt_ex

    if ( estimate.values.request_other_status != 6 ) {
      return {
        estimate_detail_name_ex:null,
        estimate_detail_amt_ex:null
      }
    }

    if (estimate_detail_name_ex != null && estimate_detail_amt_ex == null) {
      return {
        estimate_detail_name_ex:null,
        estimate_detail_amt_ex:[GetMessage(2547)]
      }
    }
    else if (estimate_detail_name_ex == null && estimate_detail_amt_ex != null) {
      return {
        estimate_detail_name_ex:[GetMessage(2546)],
        estimate_detail_amt_ex:null
      }
    }
    return {
      estimate_detail_name_ex:null,
      estimate_detail_amt_ex:null
    }
  }
  validateCallback(newData, callback=()=>{}){
    const data = this.state.estimate;
    const request_other_status = newData.values.request_other_status ? newData.values.request_other_status : this.state.estimate.values.request_other_status;
    const estimate_detail_amt_ex = this.isNull(newData.values.estimate_detail_amt_ex) ? 0 :  parseInt( newData.values.estimate_detail_amt_ex)
    // console.log(newData.values)
    let {
      invoice_amt,
      survey_tax_in_flag,
      quote_subtotal_amt,
      quote_tax_amt,
      quote_total_amt
    } = this.state.estimate.values

    if (request_other_status == 6) {
      invoice_amt = newData.values.invoice_amt? newData.values.invoice_amt: invoice_amt
      survey_tax_in_flag = newData.values.survey_tax_in_flag? newData.values.survey_tax_in_flag: survey_tax_in_flag
      quote_subtotal_amt = invoice_amt + estimate_detail_amt_ex
      quote_tax_amt = Math.floor(survey_tax_in_flag == 0 ? (invoice_amt * 0.1) : invoice_amt - invoice_amt / 1.1)
      quote_total_amt = survey_tax_in_flag == 0 ? quote_subtotal_amt + quote_tax_amt : quote_subtotal_amt
    }


    this.setState({
      estimate:{
        ...data,
        ...newData,
        values : {
          ...data.values,
          ...newData.values,
          invoice_amt : invoice_amt,
          estimate_detail_amt: invoice_amt,
          quote_subtotal_amt : quote_subtotal_amt,
          quote_tax_amt : quote_tax_amt,
          quote_total_amt : quote_total_amt
        },
        errors : {
          ...newData.errors,
          invoice_amt : request_other_status != 6 
            ? undefined 
            : newData.errors.invoice_amt 
              ? newData.errors.invoice_amt 
              : (invoice_amt === null || invoice_amt === undefined)
                ? [GetMessage(2024)] 
                : undefined,
          ...this.validateEstimateDetailEx({...data,...newData})
        }
      }
    }, ()=>callback()) 
  }

  bodyContent(){
    const status = this.state.estimate.values.request_other_status;

    const {
      quote_subtotal_amt,
      estimate_detail_amt,
      estimate_detail_amt_ex
    } = this.state.estimate.values


    // console.log(this.state.estimate)
    // console.log(this.props)

    let subtotal_amt_text = Format.comma_delimited(quote_subtotal_amt, "円") + "（課税項目小計：" + Format.comma_delimited(estimate_detail_amt, "円") + "、非課税項目小計：" + Format.comma_delimited(estimate_detail_amt_ex, "円）")

    return(
      <>
        <Table>
          <tbody>
            <tr>
              <CustomTd label='請求金額'
                name='INVOICE__invoice_amt'
                copy={false}
                rootData={this.state.estimate}
                value={
                  <InputNumber
                    disabled={(status < 6) ? true : false}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                    unit="円"
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd label='税'
                name='ESTIMATE__survey_tax_in_flag'
                copy={false}
                rootData={this.state.estimate}
                noBorder={true}
                value={
                  <InputRadio
                    disabled={(status < 6) ? true : false}
                    options={cst_tax_in_flag}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd label='その他非課税項目名'
                name='ESTIMATE_DETAIL__estimate_detail_name_ex'
                copy={false}
                rootData={this.state.estimate}
                noBorder={true}
                value={
                  <InputText
                    disabled={(status < 6) ? true : false}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd label='その他非課税金額'
                name='ESTIMATE_DETAIL__estimate_detail_amt_ex'
                copy={false}
                rootData={this.state.estimate}
                noBorder={true}
                value={
                  <InputText
                    disabled={(status < 6) ? true : false}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd 
                label="小計" 
                name="ESTIMATE__quote_subtotal_amt"
                copy={false}
                value={subtotal_amt_text}
                noBorder={true}
              />
            </tr>
            <tr>
              <CustomTd 
                label="税額" 
                name="ESTIMATE__quote_tax_amt"
                copy={false}
                value={Format.comma_delimited(this.state.estimate.values.quote_tax_amt, "円")}
                noBorder={true}
              />
            </tr>
            <tr>
              <CustomTd 
                label="合計" 
                name="ESTIMATE__quote_total_amt"
                copy={false}
                value={Format.comma_delimited(this.state.estimate.values.quote_total_amt, "円")}
                noBorder={true}
              />
            </tr>
            <tr>
              <CustomTd label='着手期限日'
                    name='REQUEST__request_other_deadline'
                    copy={false}
                    rootData={this.state.estimate}
                    value={
                      <InputDatetime
                        validateCallback={this.validateCallback} 
                        validateType='regist'
                      />
                    }
                />
            </tr>            
            <tr>
              <CustomTd label='経理課への請求連絡事項'
                name='INVOICE__invoice_user_memo'
                copy={false}
                rootData={this.state.estimate}
                value={
                  <InputText multiline={true}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
            <CustomTd label='ステータス'
              name='REQUEST__request_other_status'
              copy={false}
              rootData={this.state.estimate}
              value={
                  <InputRadio
                  options={cst_request_other_status}
                  validateCallback={this.validateCallback} 
                  validateType='regist'
                  />
              }
            />
            </tr>
          </tbody>
        </Table>
        <hr />
        {!this.state.estimate.invoiceInfoIsSet &&
        <div style={{width: "280px", padding: "2px", marginBottom: "2px", border: "1px solid #FF0000"}}>
          <font color="red">適格事業者番号が登録されていません。</font>
        </div>
        }
        {this.state.disablePositive &&
        <div style={{width: "280px", padding: "2px", marginBottom: "2px", border: "1px solid #FF0000"}}>
          <font color="red">仕入が失注しているため、完了できません</font>
        </div>
        }
        {this.props.isFuture &&
        <div style={{width: "280px", padding: "2px", marginBottom: "2px", border: "1px solid #FF0000"}}>
          <font color="red">月締め済みのため、完了にできません</font>
        </div>
        }
      </>
    );
  }
}
export class DialogCloseProject extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '案件Close',
      estimate: {
        values:this.props.data,
        errors:{},
        requiredData:{
        }
      }
    });
    this.validate = this.validate.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
  }

  componentDidUpdate(prevProps, prevState){

    if(prevProps.data !== this.props.data || prevState.modal !== this.state.modal){
      this.setState({
        estimate: {
          ...this.state.estimate,
          values: {
            ...this.props.data,
            invoice_user_memo : this.props.data.order_memo,
          },
          errors: {}
        }
      });
    }
  }

  validate() {
    let message = getErrorCodes(this.state.estimate.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    this.props.handleClickPositive && this.props.handleClickPositive();
    
    if(this.validate()) {

      const params = {
        ...this.state.estimate.values,
        order_memo:this.state.estimate.values.invoice_user_memo,
        survey_status:9
      }

      const url = '/api/request/other/close/' + this.state.estimate.values.ulid;
      Request.put(url, params, res => {
        this.toggleModal();
        this.props.refreshCallback();
      });
    }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.toggleModal();
  }

  validateCallback(newData, callback=()=>{}){
    const data = this.state.estimate;
    data.values["invoice_user_memo"] = newData.values.invoice_user_memo
    this.setState({
      estimate:{
        ...data,
      }
    }, ()=>callback())
  }

  bodyContent(){
    
    return(
      <>
        <p className="border-top py-3">
          案件をCloseします。よろしいですか？
        </p>
        
        案件状況メモ
        <InputText
          name='INVOICE__invoice_user_memo'
          multiline={true}
          validateCallback={this.validateCallback} 
          validateType='regist'
          rootData={this.state.estimate}
        />
      </>    
    );
  }
}
export class DialogConfirmEstimate extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '見積確認',
      negative: false,
      newtral: true,
      positive_label: "更新",
      estimate: {
        values:this.props.data,
        errors:{},
        requiredData:{
          request_other_deadline:[GetMessage(2024)], 
        }
      },
    });
    this.validate = this.validate.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.data !== this.props.data || prevState.modal !== this.state.modal){
      this.setState({
        estimate: {
          ...this.state.estimate,
          values: {
            ...this.props.data,
          },
/*
          errors: {
            survey_cost_commission : this.props.data.survey_cost_commission ? undefined : [GetMessage(2024)],
          },
          requiredData:{
            survey_cost_commission:[GetMessage(2024)], 
          }
*/
        },
      });
    }
  }

  validate() {
    let message = getErrorCodes(this.state.estimate.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    this.props.handleClickPositive && this.props.handleClickPositive();
    
    if(this.validate()) {
      // 調整額 更新API呼び出し
      // url put estimate??? need to check after testable data created
      
      const params = {
        ...this.state.estimate.values,
        survey_cost_commission_invoice_registration_number:this.state.estimate.values.survey_cost_commission_invoice_business_type== "1" ? this.state.estimate.values.survey_cost_commission_invoice_registration_number : "",
      }
      const url = '/api/request/other/estimate/' + this.state.estimate.values.ulid;
      Request.put(url, params, res => {
        this.toggleModal();
        this.props.refreshCallback();
      });
    }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.toggleModal();
  }

  isNull(value){
    if(value === undefined || value === null || value === ""){
      return true
    }
    return false;
  }
  validateCallback(newData, callback=()=>{}){
    const data = this.state.estimate;
    let {
      survey_tax_in_flag,
      survey_cost_commission_invoice_business_type,
      survey_cost_commission_invoice_registration_number
    } = newData.values

    console.log(data.values, newData.values);

    const survey_cost_parking_rent = this.isNull(newData.values.survey_cost_parking_rent) ? 0 : newData.values.survey_cost_parking_rent
    const estimate_detail_amt = this.isNull(newData.values.estimate_detail_amt) ? 0 : newData.values.estimate_detail_amt
    const estimate_detail_amt_ex = this.isNull(newData.values.estimate_detail_amt_ex) ? 0 : newData.values.estimate_detail_amt_ex
    
    const quote_subtotal_amt = survey_cost_parking_rent + estimate_detail_amt + estimate_detail_amt_ex
    const _subtotal_amt = survey_cost_parking_rent + estimate_detail_amt
    const _CAL_quote_tax_amt = Math.floor(survey_tax_in_flag == 0 
                                          ? (_subtotal_amt) * 0.1 
                                          : _subtotal_amt > 0 
                                            ? _subtotal_amt / 11 
                                            : 0)
    console.log(_CAL_quote_tax_amt)
    const quote_total_amt =  survey_tax_in_flag == 0 ? quote_subtotal_amt + _CAL_quote_tax_amt : quote_subtotal_amt


    let errors = {};
    switch (survey_cost_commission_invoice_business_type) {
      case "1":{
        survey_cost_commission_invoice_registration_number = survey_cost_commission_invoice_registration_number != null? survey_cost_commission_invoice_registration_number: ""
        if (survey_cost_commission_invoice_registration_number.length>0 && !survey_cost_commission_invoice_registration_number.match(/^T\d{13}$/)) {
          errors = {survey_cost_commission_invoice_registration_number:[GetMessage(2035)]}
        }
        if (survey_cost_commission_invoice_registration_number == null || survey_cost_commission_invoice_registration_number.length == 0) {
          errors = {survey_cost_commission_invoice_registration_number:[GetMessage(2601)]}
        }
      }break;
      case "0":{
        errors = {survey_cost_commission_invoice_registration_number:[GetMessage(2603)]}
      }break;
      default:{
        errors = {survey_cost_commission_invoice_registration_number:undefined}
      }
    }

    this.setState({
      estimate:{
        ...data,
        ...newData,
        values : {
          ...newData.values,
          survey_cost_parking_rent : survey_cost_parking_rent,
          quote_subtotal_amt : quote_subtotal_amt,
          quote_tax_amt : _CAL_quote_tax_amt,
          quote_total_amt : quote_total_amt,
          survey_tax_in_flag: survey_tax_in_flag,
        },
        errors : {
          ...newData.errors,
          // ...(this.isNull(newData.values.estimate_detail_name) && !this.isNull(newData.values.estimate_detail_amt) ? {estimate_detail_name:[GetMessage(2024)]} : ""),
          // ...(this.isNull(newData.values.estimate_detail_amt) && !this.isNull(newData.values.estimate_detail_name) ? {estimate_detail_amt:[GetMessage(2024)]} : ""),
          ...(this.isNull(newData.values.estimate_detail_name_ex) && !this.isNull(newData.values.estimate_detail_amt_ex) ? {estimate_detail_name_ex:[GetMessage(2024)]} : {estimate_detail_name_ex:undefined}),
          ...(this.isNull(newData.values.estimate_detail_amt_ex) && !this.isNull(newData.values.estimate_detail_name_ex) ? {estimate_detail_amt_ex:[GetMessage(2024)]} : {estimate_detail_amt_ex:undefined}),
          ...errors
        }
      }
    }, ()=>callback())
  }

  bodyContent(){
    const taxable_total = (this.isNull(this.state.estimate.values.estimate_detail_amt) ? 0 : this.state.estimate.values.estimate_detail_amt) + (this.isNull(this.state.estimate.values.survey_cost_parking_rent) ? 0 : this.state.estimate.values.survey_cost_parking_rent)
    const non_taxable_total = this.isNull(this.state.estimate.values.estimate_detail_amt_ex) ? 0 : this.state.estimate.values.estimate_detail_amt_ex
    const status = this.state.estimate.values.request_other_status;
    return(
      <>
        <Card className="detail">
          <CardHeader>
            <CardTitle tag="h4" className="float-left">仕入金額</CardTitle>
          </CardHeader>
          <Table>
            <tbody>
              <tr>
                <CustomTd label='手数料'
                  name='ESTIMATE__survey_commission'
                  colSpan="4"
                  copy={false}
                  rootData={this.state.estimate}
                  tdBackgroundColor ='subTitle-orange'
                  value={
                    <Row>
                      <Col md="4">
                        <InputNumber
                          name='ESTIMATE__survey_cost_commission'
                          size={10}
                          unit="円"
                          rootData={this.state.estimate}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                          disabled={true}
                        />
                      </Col>
                      <Col md="8">
                        <InputInvoice
                          label="支払先&nbsp;"
                          labelOn={true}
                          rows={false}
                          names={{
                            payment_type: false,
                            business_type: "ESTIMATE__survey_cost_commission_invoice_business_type",
                            registration_number: "ESTIMATE__survey_cost_commission_invoice_registration_number",
                            with_unconfirmed: "ESTIMATE__survey_cost_commission_invoice_business_type"
                          }}
                          rootData={this.state.estimate}
                          validateCallback={this.validateCallback}
                          visible={true}
                        />
                      </Col>
                    </Row>
                  }
                />
              </tr>
            </tbody>
          </Table>
          <CardHeader>
            <CardTitle tag="h4" className="float-left">見積金額</CardTitle>
          </CardHeader>
          <Table>
            <tbody>
              <tr>
                <CustomTd label='見積金額'
                  name='INVOICE__survey_cost_parking_rent'
                  colSpan="4"
                  copy={false}
                  rootData={this.state.estimate}
                  tdBackgroundColor ='subTitle-orange'
                  value={
                    <InputNumber
                      disabled={false}
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      unit="円"
                    />
                  }
                />
              </tr>
              {/* <tr>
                <CustomTd label='その他課税項目名'
                    name='ESTIMATE_DETAIL__estimate_detail_name'
                    copy={false}
                    rootData={this.state.estimate}
                    tdBackgroundColor ='subTitle-orange'
                    value={
                      <InputText
                        validateCallback={this.validateCallback} 
                        validateType='regist'
                        disabled={false}
                      />
                    }
                />
                <CustomTd label='その他課税金額'
                    name='ESTIMATE_DETAIL__estimate_detail_amt'
                    copy={false}
                    rootData={this.state.estimate}
                    tdBackgroundColor ='subTitle-orange'
                    value={
                      <InputNumber
                        size={10}
                        unit="円"
                        validateCallback={this.validateCallback} 
                        validateType='regist'
                        disabled={false}
                      />
                    }
                />
              </tr> */}
              <tr>
                  <CustomTd label='その他非課税項目名'
                      name='ESTIMATE_DETAIL__estimate_detail_name_ex'
                      copy={false}
                      rootData={this.state.estimate}
                      tdBackgroundColor ='subTitle-orange'
                      value={
                        <InputText
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                          disabled={false}
                        />
                      }
                  />
                  <CustomTd label='その他非課税金額'
                      name='ESTIMATE_DETAIL__estimate_detail_amt_ex'
                      copy={false}
                      rootData={this.state.estimate}
                      tdBackgroundColor ='subTitle-orange'
                      value={
                        <InputNumber
                          size={10}
                          unit="円"
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                          disabled={false}
                        />
                      }
                  />
                </tr>
                <tr>
                  <CustomTd label='見積金額小計'
                    name='ESTIMATE__quote_subtotal_amt'
                    colSpan="4"
                    copy={false}
                    rootData={this.state.estimate}
                    tdBackgroundColor ='subTitle-orange'
                    value={
                      Format.format_number_with_commas(this.state.estimate.values.quote_subtotal_amt)+"円 (課税項目小計: "+
                      Format.format_number_with_commas(taxable_total)+"円、非課税項目小計: " +
                      Format.format_number_with_commas(non_taxable_total)+"円)"
                    }
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="税" 
                    colSpan="4"
                    copy={false}
                    tdBackgroundColor ='subTitle-orange'
                    value={
                      <InputRadio options={cst_tax_in_flag}
                        validateCallback={this.validateCallback} 
                        rootData={this.state.estimate}
                        validateType="regist"
                        label="税"
                        name="ESTIMATE__survey_tax_in_flag"
                        />
                    }/>
                </tr>
                <tr>
                  <CustomTd label='税額'
                    name='ESTIMATE__quote_tax_amt'
                    colSpan="4"
                    copy={false}
                    rootData={this.state.estimate}
                    tdBackgroundColor ='subTitle-orange'
                    value={Format.format_number_with_commas(this.state.estimate.values.quote_tax_amt)+"円"}
                  />
                </tr>
                <tr>
                  <CustomTd label='見積合計'
                      name='ESTIMATE__quote_total_amt'
                      colSpan="4"
                      copy={false}
                      rootData={this.state.estimate}
                      tdBackgroundColor ='subTitle-orange'
                      value={
                        Format.format_number_with_commas(this.state.estimate.values.quote_total_amt)+"円"
                      }
                  />
                </tr>
            </tbody>
          </Table>
        </Card>
        <hr />
      </>
    );
  }
}

export default List;
